import React from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

import { api } from "../../../../../../utility/AxiosInceptor";
import { useEffect, useState } from "react";
import PaymentStripeForm from "./stripe_payment_dialog/stripe_payment_form";

let stripePromise;
export default function PaymentStripModule({
  _id,
  paid,
  plan,
  amount,
  object,
  setActiveIndex,
  setShowPreview,
  setPaymentDialogVisibility,
}) {
  let [clientSecret, setClientSecret] = useState(null);

  useEffect(() => {
    stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

    api
      .post(`/api/web/billing/paymentintent`, { amount: paid })
      .then((response) => {
        setClientSecret(response.data.clientSecret);
      })
      .catch((err) => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {clientSecret !== null ? (
        <Elements
          stripe={stripePromise}
          options={{
            clientSecret,
          }}
        >
          <PaymentStripeForm
            _id={_id}
            plan={plan}
            setShowPreview={setShowPreview}
            setPaymentDialogVisibility={setPaymentDialogVisibility}
            clientSecret={clientSecret}
            amount={amount}
            paid={paid}
            setActiveIndex={setActiveIndex}
            object={object}
          />
        </Elements>
      ) : undefined}
    </>
  );
}
